<template>
  <ul class="list-group">
    <li
      v-for="(item, index) in list"
      :key="index"
      class="list-group-item d-flex justify-content-between align-items-center"
    >
      <div class="title">
        {{ item[itemTitle] }}
        <slot
          name="title"
          :index="index"
        />
      </div>
      <slot
        :item="item"
        :index="index"
      />
      <div class="badges">
        <slot
          name="badges"
          :item="item"
        />
        <span
          v-show="Object.keys(item).includes(itemBadge)"
          class="badge badge-primary badge-pill text-right"
        >
          {{ item[itemBadge] }}
        </span>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'BootstrapListGroup',
  props: {
    list: {
      type: Array,
      required: true
    },
    itemTitle: {
      type: String,
      default: 'title'
    },
    itemBadge: {
      type: String,
      default: 'badge'
    }
  }
}
</script>
